<template>
  <div class="m-2 mb-4">
    <b-row>
      <b-col cols="12">
        <b-form-group :label="$t('Choose The Period')" label-for="report-date">
          <flat-pickr v-model="period" :state="null" class="form-control" :config="pickerConfig"
            placeholder=" " />

          <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
            :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
            {{ ('from' in errors) ? errors['from'][0] : '' }}
            {{ ('to' in errors) ? errors['to'][0] : '' }}
          </b-form-invalid-feedback>
        </b-form-group>

      </b-col>
    </b-row>
  </div>
</template>

<script>

import { BCol, BRow, BFormGroup, BButton, BForm, BFormInvalidFeedback } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import { onUnmounted, ref, onMounted, watch } from '@vue/composition-api'
import store from '@/store'

import { eventBus } from '@/main'
import moment from 'moment'
import { useRouter } from '@core/utils/utils'
import {useDateRangePicker} from '@/custms/datepicker'


export default {
  components: { BRow, BCol, BFormGroup, BButton, BForm, flatPickr, BFormInvalidFeedback },
  directives: { Ripple, },

  setup(props, { root, emit }) {
    const toDateChangeCounter = ref(0);
    const firstDate = ref(null);

    const period = ref('')

    const from = ref('')
    const to = ref('')

    const { router } = useRouter()

    const { pickerConfig } = useDateRangePicker(from, to);

    from.value = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
    to.value = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')

    const pickerOptions = {
      dateFormat: 'Y-m-d H:i:S',
      defaultDate: [
        new Date().setHours(0, 0, 0),
        new Date().setHours(23, 59, 59, 59),
      ],

      enableTime: true,
      enableSeconds: true,
      defaultHour: 0,
      mode: 'range',
      time_24hr: true,
      onClose: function (selectedDates, dateStr, instance) {
        const date = dateStr.split(' to ')
        from.value = date[0]
        to.value = date[1]

        toDateChangeCounter.value = 0;
        firstDate.value = null;
      },
      onChange(dates) {
        // switch (this.selectedDates.length) {
        //   case 1:
        //     if (this.selectedDates[0].getHours() < 0) {
        //       this.selectedDates[0].setHours(0, 0, 0, 0);
        //       this.setDate(this.selectedDates)
        //     }
        //     break;
        //   case 2:
        //     if (toDateChangeCounter.value == 0) {
        //       firstDate.value = new Date(this.selectedDates[1]);
        //     }
        //     toDateChangeCounter.value++;
        //     if (toDateChangeCounter.value < 2 || parseInt(getDeferanceInDays(firstDate.value, new Date(this.selectedDates[1]))) > 0) {
        //       this.selectedDates[1].setHours(23, 59, 59, 59);
        //       this.setDate(this.selectedDates)
        //     }
        //     break;
        // }

      }
    }



    const errors = ref(null)
   
    // eventBus.$on("getRoute", function (id, contract_id) {
    //   if (from.value != undefined && to.value != undefined) {
    //     errors.value={}
    //     getRoute(id, contract_id)
    //
    //    }else{
    //     if(from.value==undefined){  errors.value={from:['from date not selected']}}
    //     if(to.value==undefined){  errors.value={from:['to date not selected']}}
    //     root.$swal({
    //     title: root.$i18n.t("Are You Sure"),
    //     text: root.$i18n.t("you should select from to date to show route"),
    //     showCancelButton: false,
    //     confirmButtonText: root.$i18n.t('OK'),
    //     customClass: {
    //       confirmButton: 'btn btn-primary',
    //
    //     },
    //     buttonsStyling: false,
    //   })
    //
    //   }
    //
    // })


    eventBus.$on("getRoute", function (id, contract_id) {
      if (from.value !== undefined && to.value !== undefined) {
        errors.value = {}
        getRoute(id, contract_id)

      }else{
        if(from.value === undefined){  errors.value={from:['from date not selected']}}
        if(to.value === undefined){  errors.value={from:['to date not selected']}}
        root.$swal({
          title: root.$i18n.t("Are You Sure"),
          text: root.$i18n.t("you should select from to date to show route"),
          showCancelButton: false,
          confirmButtonText: root.$i18n.t('OK'),
          customClass: {
            confirmButton: 'btn btn-primary',

          },
          buttonsStyling: false,
        })

      }

    })


    eventBus.$on("getRoute2", function (id) {
      if (from.value !== undefined && to.value !== undefined) {
        errors.value = {}
        getRoute2(id)

      }else{
        if(from.value === undefined){  errors.value={from:['from date not selected']}}
        if(to.value === undefined){  errors.value={from:['to date not selected']}}
        root.$swal({
          title: root.$i18n.t("Are You Sure"),
          text: root.$i18n.t("you should select from to date to show route"),
          showCancelButton: false,
          confirmButtonText: root.$i18n.t('OK'),
          customClass: {
            confirmButton: 'btn btn-primary',

          },
          buttonsStyling: false,
        })

      }

    })

    eventBus.$on("getRouteLive", function (id, contract_id) {
      getRouteLive(id, contract_id)
    })

    eventBus.$on("getLiveTrk", function (id) {
      window.open(
          `/device/${id}/live`,
          '_blank',
          'height=800,width=1500'
      )
    })


    eventBus.$on('getCamLive',  (id) => {
      window.open(
          `/cam/live.html?device=${id}`,
          '_blank',
          'height=900,width=1500'
      )
    })

    eventBus.$on('getCamPlayback',  (id) => {
      window.open(
          `/cam/playback.html?device=${id}&from=${from.value}&to=${to.value}`,
          '_blank',
          'height=900,width=1500'
      )
    })


    eventBus.$on('getRfidPlan',  (id) => {
      window.open(
          `/device/${id}/getRoute/from/${from.value}/to/${to.value}`,
          '_blank',
          'height=800,width=1500'
      )
    })

    eventBus.$on('trackCompactorPlan',  (id) => {
      window.open(
          `/compactor/${id}/path`,
          '_blank',
          'height=800,width=1500'
      )
    })

    function openWindow(sUrl, sName, sProps) {
      document.MyActiveWindows.push(window.open(sUrl, sName, sProps))
    }

    function closeAllWindows() {
      for (var i = 0; i < document.MyActiveWindows.length; i++)
        document.MyActiveWindows[i].close()
    }


    //old history map
    const getRoute = (id, contract_id) => {
        document.MyActiveWindows = new Array;
        let routeData = router.resolve({ name: 'tracking.route', params: { id: id, from: from.value, to: to.value, contract_id: contract_id } })
        const windowFeatures = "";
        history.go = function () { };
        closeAllWindows()
        openWindow(routeData.href, 'route', "menubar=1,resizable=1,width=" + screen.width + ",height=" + screen.height)
    }


    // new history map
    const getRoute2 = id => {
      window.open(
          `/device/${id}/history?from=${from.value}&to=${to.value}`,
          '_blank',
          'height=800,width=1500'
      )
    }

    const getRouteLive = (id, contract_id) => {
      document.MyActiveWindows = new Array;
      let routeData = router.resolve({ name: 'tracking.routeLive', params: { id: id, from: from.value, to: to.value, contract_id: contract_id } })
      const windowFeatures = "";
      history.go = function () { };
      closeAllWindows()
      openWindow(routeData.href, 'route', "menubar=1,resizable=1,width=" + screen.width + ",height=" + screen.height)
    }


    return {
      pickerConfig,
      // pickerOptions,
      from, to, period,
      getRoute,
      getRouteLive,
      errors,
    }

  }
}
</script>
<style scoped>

</style>
